import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Skeleton,
} from "@heroui/react";
import { api } from "../../../lib/api-client";
import SubscriptionFormDrawer from "./SubscriptionFormDrawer";
import { SubscriptionsFilter } from "./components/SubscriptionsFilter";
import { SubscriptionCard } from "./components/SubscriptionCard";
import { useSearchParams } from "react-router";

export const SubscriptionsTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const searchQueryRaw = searchParams.get("q");
  const sortByRaw = searchParams.get("sortBy");
  const showInactiveRaw = searchParams.get("showInactive");
  const selectedSubscriptionIdRaw = searchParams.get("sid");

  // Parse values from URL
  const searchQuery = searchQueryRaw ?? "";
  const sortBy: "createdAtAsc" | "createdAtDesc" =
    sortByRaw === "createdAtAsc" || sortByRaw === "createdAtDesc"
      ? sortByRaw
      : "createdAtDesc";
  const showInactive = showInactiveRaw === "true";
  const selectedSubscriptionId = selectedSubscriptionIdRaw
    ? parseInt(selectedSubscriptionIdRaw)
    : undefined;

  const setSearchQuery = (query: string) => {
    setSearchParams((prev) => {
      if (query === "") {
        prev.delete("q");
      } else {
        prev.set("q", query);
      }
      return prev;
    });
  };

  const setSortBy = (sort: "createdAtAsc" | "createdAtDesc") => {
    setSearchParams((prev) => {
      prev.set("sortBy", sort);
      return prev;
    });
  };

  const setShowInactive = (show: boolean) => {
    setSearchParams((prev) => {
      if (show) {
        prev.set("showInactive", "true");
      } else {
        prev.delete("showInactive");
      }
      return prev;
    });
  };

  const {
    data: subscriptions,
    isLoading,
    refetch,
  } = api.subscription.useGetSubscriptions({
    search: searchQuery !== "" ? searchQuery : undefined,
    includeInactive: showInactive,
    includeDeleted: false,
    sortBy: sortBy,
  });

  return (
    <>
      <SubscriptionFormDrawer
        isOpen={selectedSubscriptionId != null}
        onSuccess={() => {
          setSearchParams((prev) => {
            prev.delete("sid");
            return prev;
          });
        }}
        subscriptionId={selectedSubscriptionId}
      />

      <SubscriptionsFilter
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        sortBy={sortBy}
        setSortBy={setSortBy}
        showInactive={showInactive}
        setShowInactive={setShowInactive}
      />

      <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-4">
        {isLoading
          ? [...Array(6)].map((_, index) => (
              <Skeleton isLoaded={!isLoading} className="min-h-64 rounded-xl">
                <Card key={index} shadow="sm" radius="sm">
                  <CardHeader className="flex items-center justify-between"></CardHeader>
                  <CardBody></CardBody>
                  <CardFooter></CardFooter>
                </Card>
              </Skeleton>
            ))
          : subscriptions?.map((subscription) => (
              <Skeleton isLoaded={!isLoading} className="min-h-64 rounded-xl">
                <SubscriptionCard
                  key={subscription.id}
                  subscription={subscription}
                  onEdit={(subscription) => {
                    setSearchParams((prev) => {
                      prev.set("sid", subscription.id.toString());
                      return prev;
                    });
                  }}
                  refetchSubscriptions={refetch}
                />
              </Skeleton>
            ))}
      </div>
    </>
  );
};
